import { useContext, useState, useEffect } from "react"
import { fnFormatDateFromUTC } from "../../../../../../../utils/date"
import AuthContext from "../../../../../../../contexts/Auth"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import { Flex } from "@stardust-ds/react"
import TextTruncate from "../../../../../../atoms/TextTruncate"

export const CardLevel = ({ level, color, isDisabled, item, user }) => {
  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone

  const fnRunDate = (dateAndHour) => {
    const [data, hour] = fnFormatDateFromUTC(
      dateAndHour,
      "DD/MM/YYYY - HH:mm",
      cUserTimeZone,
    ).split(" - ")

    return `${data} - ${hour}`
  }

  const isDataWestgard = !!item.eqpanltlaunch_awestgard_rules?.length
  const isDataInterControl = item.eqpanltlaunch_awestgard_rules?.some(
    (it) => it.eqpanltlnchwgr_type === "inter",
  )
  const isDataIntraControl = item.eqpanltlaunch_awestgard_rules?.some(
    (it) => it.eqpanltlnchwgr_type === "intra",
  )

  const cLaunchAuthor = item?.eqpanltlaunch_user?.cname
    ? item.eqpanltlaunch_user.cname
    : item?.eqpanltlaunch_customer_application?.custapp_cname

  return (
    <div
      className={styles.containerCardLevel}
      style={{
        borderColor: color,
        padding: isDisabled ? "0.5rem 1rem" : "0rem 0.4rem 0.6rem",
        opacity: isDisabled ? 0.5 : 1,
      }}
    >
      {isDisabled ? (
        <div className={styles.disabled}>
          <h3
            style={{
              color: color,
            }}
          >
            {level}
          </h3>
          <p>-</p>
        </div>
      ) : (
        <>
          <div className={styles.lineLevel}>
            <h3
              className={styles.level}
              style={{
                color: color,
              }}
            >
              {level}
            </h3>
            <p
              className={`${styles.levelContent} ${
                item?.eqpanltlaunch_resultopt_ecompliance?.toLowerCase().includes("n") &&
                item.type_analyte !== "Quantitativo"
                  ? styles.negative
                  : ""
              }`}
            >
              {item.type_analyte === "Quantitativo"
                ? item.eqpanltlaunch_nvalue || 0
                : item.eqpanltlaunch_resultopt_cdescription || ""}
            </p>
          </div>

          <div className={styles.column}>
            {item.type_analyte == "Quantitativo" && (
              <>
                <div className={styles.content}>
                  <p className={styles.title}>
                    {intl.get("ciq.difference_relation_average")}
                  </p>
                  <p className={styles.normal}>
                    {item.eqpanltlaunch_drm
                      ? Number(item.eqpanltlaunch_drm).toFixed(2)
                      : "n/a"}
                  </p>
                </div>

                <div className={styles.content}>
                  <p className={styles.normal}>
                    {intl.get("ciq.modal_create_analytos.fields.coef_variation")}:
                  </p>
                  <p className={styles.normal}>
                    {item.eqpanltlaunch_ncoefficient_variation
                      ? Number(item.eqpanltlaunch_ncoefficient_variation).toFixed(2) +
                        " %"
                      : "n/a"}
                  </p>
                </div>
              </>
            )}
            <div className={styles.content}>
              <p className={styles.normal}>{intl.get("ciq.control")}:</p>
              <p className={styles.normal}>{item.eqpanltlaunch_control.control_cname}</p>
            </div>
            <div className={styles.content}>
              <p className={styles.normal}>{intl.get("ciq.n_bacth")}</p>
              <p className={styles.normal}>{item.eqpanltlaunch_cbatch}</p>
            </div>

            {cLaunchAuthor && (
              <div className={styles.content}>
                <p className={styles.normal}>
                  {cLaunchAuthor} • {intl.get("ciq.released_at")}:{" "}
                  {fnRunDate(item.eqpanltlaunch_dupdated).replace(
                    " - ",
                    ` ${intl.get("ciq.at")} `,
                  )}
                </p>
              </div>
            )}
            <LaunchObservation oLaunch={item} />
            {item.type_analyte == "Quantitativo" && (
              <div className={styles.column}>
                <div>
                  {isDataWestgard && isDataIntraControl ? (
                    <p className={styles.normal}>{intl.get("ciq.intra_control")}: </p>
                  ) : (
                    <div>
                      <p className={styles.normal}>{intl.get("ciq.intra_control")}: </p>
                      <p className={styles.notData}>N/A</p>
                    </div>
                  )}
                  <div className={styles.westigardRules}>
                    {item.eqpanltlaunch_awestgard_rules.map((item, index) => {
                      if (item.eqpanltlnchwgr_type === "intra") {
                        return (
                          <div
                            key={index}
                            className={
                              item.eqpanltlnchwgr_eaction?.toLowerCase().includes("r")
                                ? styles.cardRed
                                : styles.cardOrange
                            }
                          >
                            {item.eqpanltlnchwgr_wgrdr_cname}
                          </div>
                        )
                      }
                    })}
                  </div>
                </div>
                <div>
                  {isDataWestgard && isDataInterControl ? (
                    <p className={styles.normal}>{intl.get("ciq.inter_control")}: </p>
                  ) : (
                    <div>
                      <p className={styles.normal}>{intl.get("ciq.inter_control")}: </p>
                      <p className={styles.notData}>N/A</p>
                    </div>
                  )}
                  <div className={styles.westigardRules}>
                    {item.eqpanltlaunch_awestgard_rules.map((item, index) => {
                      if (item.eqpanltlnchwgr_type === "inter") {
                        return (
                          <div
                            key={index}
                            className={
                              item.eqpanltlnchwgr_eaction?.toLowerCase().includes("r")
                                ? styles.cardRed
                                : styles.cardOrange
                            }
                          >
                            {item.eqpanltlnchwgr_wgrdr_cname}
                          </div>
                        )
                      }
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

const LaunchObservation = (props) => {
  const { oLaunch } = props

  const cObservation = oLaunch?.eqpanltlaunch_cobservation

  if (!cObservation) return null
  return (
    <Flex
      width="100%"
      alignItems="flex-start"
      justifyContent="flex-start"
      flexDirection="column"
    >
      <p className={styles.normal}>{intl.get("ciq.observation")}:</p>
      <TextTruncate className={styles.observation} cText={cObservation} nTextMaxLenght={130} />
    </Flex>
  )
}